import { ColorsVariantEnum } from './colors-variant-enum';
import ColorConstants from '../constants/ColorConstants';

export const getBackgroundColor = (variant: ColorsVariantEnum = ColorsVariantEnum.DEFAULT) => {
    const colors = {
        [ColorsVariantEnum.ADDING]: ColorConstants.ADDING_LIGHT,
        [ColorsVariantEnum.DEFAULT]: ColorConstants.white,
        [ColorsVariantEnum.DESCTRUCTIVE]: ColorConstants.DESTRUCTIVE_LIGHT,
    };

    return `background-color: ${colors[variant]};`;
};
